import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installDemoStorageHelper } from './utils/clearDemoStorage';

// Expose window.clearDemoStorage() for browser-console use during demos.
// Wipes onboarding flags + KIRA prefill so the welcome modal triggers
// fresh on next login. Auth tokens are preserved.
installDemoStorageHelper();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <App />
  );

// Hide loading screen once React mounts
const loader = document.getElementById('app-loading');
if (loader) {
  loader.style.transition = 'opacity 0.3s ease';
  loader.style.opacity = '0';
  setTimeout(() => loader.remove(), 300);
}

// PWA service worker registration. Skipped in dev to avoid stale-cache pain.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('SW registered:', reg.scope))
      .catch((err) => console.log('SW error:', err));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
